module.exports = __webpack_public_path__ + "img/Macc.8cb538bb.svg";